{
    "ControlsAgentButtonTitle": "Mostrar todos os controlos disponíveis para o agente",
    "ControlsDeviceButtonTitle": "Mostrar todos os controlos disponíveis para o dispositivo",
    "NAME": "StaticAgentControls"
}